import { useState, useEffect, useCallback } from "react";
import { fetchSources } from "../api/sources";
import type { SourceEntry } from "../types";

export function useSources() {
  const [sources, setSources] = useState<SourceEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = useCallback(() => {
    setRefreshKey((k) => k + 1);
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchSources()
      .then(setSources)
      .catch((e) => setError(e instanceof Error ? e.message : "Fehler"))
      .finally(() => setLoading(false));
  }, [refreshKey]);

  return { sources, loading, error, refresh };
}
